const Header = () => <header><h1>Joel Milligan</h1></header>;

export default Header;